import { Component } from '@nicolas-riciotti/light2'
import Utils from '../../helpers/Utilities'

export default class CoreAnimatedGif extends Component {

  constructor() {
    super()

    // Elements.
    this.$image = null
    this.$canvas = null

    // State.
    this.width = 0
    this.height = 0
    this.imageWidth = 0
    this.imageHeight = 0
    this.paused = false
  }

  attached() {
    Utils.classnameFix(this)

    // Get animated image.
    this.$image = this.querySelector('img')
    this.imageWidth = this.$image.naturalWidth
    this.imageHeight = this.$image.naturalHeight

    // Create canvas element.
    this.$canvas = document.createElement('canvas')
    this.$canvas.width = this.imageWidth
    this.$canvas.height = this.imageHeight
    this.$canvas.className = 'absolute top-0 left-0 w-full h-full z-10'
    this.$canvas.setAttribute('aria-hidden', 'true')
    this.$canvas.setAttribute('role', 'presentation')
    this.insertBefore(this.$canvas, this.$image)

    this.resize()
  }

  play() {
    this.paused = false
    this.$canvas.style.visibility = 'hidden'
  }

  pause() {
    this.paused = true
    this.draw(0, 0, this.width, this.height)
    this.$canvas.style.visibility = ''
  }

  draw() {
    if (this.paused && this.width && this.height) {
      // Resize values.
      const resizeRatio = Math.max(this.width / this.imageWidth, this.height / this.imageHeight)
      const resizeWidth = this.imageWidth * resizeRatio
      const resizeHeight = this.imageHeight * resizeRatio
      // Cropping values.
      const offsetX = 1 / 2
      const offsetY = 1 / 2
      const sWidth = this.imageWidth / (resizeWidth / this.width)
      const sHeight = this.imageHeight / (resizeHeight / this.height)
      const sX = (this.imageWidth - sWidth) * offsetX
      const sY = (this.imageHeight - sHeight) * offsetY
      // Draw image.
      this.$canvas.getContext('2d').drawImage(this.$image, sX, sY, sWidth, sHeight, 0, 0, this.imageWidth, this.imageHeight)
    }
  }

  resize() {
    const rect = this.getBoundingClientRect()
    this.width = rect.width
    this.height = rect.height
    this.draw()
  }
}


if (!customElements.get('core-animated-gif')) {
  customElements.define('core-animated-gif', CoreAnimatedGif);
}
